import { computed } from 'vue';

import { useProfile } from '@/use/profile';

export const useAffiliate = () => {
  const { currentUser } = useProfile();

  const id = computed(() => currentUser.value?.affiliate?.id);

  const extension = computed(() => currentUser.value?.affiliate?.extension);

  const codeName = computed(() => currentUser.value?.affiliate?.codeName);

  return {
    id,
    extension,
    codeName,
  };
};
